import { useQuery } from '@tanstack/react-query';

import { useReplyDraftsGateway } from './ReplyDraftsGatewayProvider';
import { getReplyDraftSourceV2QueryOptions } from '../api/queryOptions';

/** The catalog record behind a source the expert opened. */
export function useSourcePublication(publicationId: number) {
  return useQuery(getReplyDraftSourceV2QueryOptions(publicationId, useReplyDraftsGateway()));
}
